import { Select, Input } from "antd";
import { memo } from "react";
import styles from "./Condition.module.css";
import ConvertNumbersToEn from "../../../Util/ConvertNumbersToEn";

const Condition = (props) => {
  const { onChange, questions } = props;

  let selectedQuestion = null;
  for (let i = 0; i < questions.length; i++) {
    const element = questions[i];
    const questionId = `${element.id}`;
    if (questionId === `${props.main.questionId}`) {
      selectedQuestion = element;
      break;
    } else if (Array.isArray(element.questions)) {
      for (let j = 0; j < element.questions.length; j++) {
        const subQ = element.questions[j];
        const subQId = `${subQ.id}`;
        if (`${subQId}` === `${props.main.questionId}`) {
          selectedQuestion = subQ;
          break;
        }
      }
    }
  }

  const getIndex = (id) => {
    return questions
      .filter((e) => e.field_type !== "break" && e.field_type !== "html")
      .findIndex((v) => v.id === id);
  };

  return (
    <div className={styles.Condition}>
      <Select
        showSearch
        filterOption={(input, option) => {
          return option?.textLabel?.search(ConvertNumbersToEn(input)) !== -1;
        }}
        onChange={(value) => {
          onChange("main", { ...props.main, questionId: value });
        }}
        value={props.main.questionId ? `${props.main.questionId}` : null}
      >
        {questions.map((q) => {
          const questionId = `${q.id}`;

          if (
            q.field_type === "break" ||
            q.field_type === "html" ||
            q.field_type === "date"
          )
            return null;
          if (
            Array.isArray(q.options) &&
            q.options.length > 0 &&
            q.field_type === "multitext"
          ) {
            return (
              <Select.OptGroup
                textLabel={`${getIndex(q.id) + 1} - ${q.label}`}
                label={
                  <p>
                    {getIndex(q.id) + 1} - {q.label}
                  </p>
                }
              >
                {q.options.map((subQ, mi) => {
                  const subQId = `${subQ.id}`;
                  return (
                    <Select.Option
                      value={subQId}
                      textLabel={`${getIndex(q.id) + 1}.${mi + 1} - ${
                        subQ.label
                      }`}
                    >
                      {getIndex(q.id) + 1}.{mi + 1} - {subQ.label}
                    </Select.Option>
                  );
                })}
              </Select.OptGroup>
            );
          }

          if (Array.isArray(q.questions) && q.questions.length > 0) {
            return (
              <Select.OptGroup
                textLabel={`${getIndex(q.id) + 1} - ${q.label}`}
                label={
                  <p>
                    {getIndex(q.id) + 1} - {q.label}
                  </p>
                }
              >
                {q.questions.map((subQ, subIndex) => {
                  const subQId = `${subQ.id}`;
                  return (
                    <Select.Option
                      value={subQId}
                      textLabel={`${getIndex(q.id) + 1}.${subIndex + 1} - ${
                        subQ.label
                      }`}
                    >
                      {`${getIndex(q.id) + 1}.${subIndex + 1} - ${subQ.label}`}
                    </Select.Option>
                  );
                })}
              </Select.OptGroup>
            );
          }

          return (
            <Select.Option
              value={questionId}
              textLabel={
                q.field_type !== "html" && q.field_type !== "break"
                  ? `${getIndex(q.id) + 1} - ${q.label}`
                  : q.label
              }
            >
              {q.field_type !== "html" && q.field_type !== "break" && (
                <p1>{getIndex(q.id) + 1} - </p1>
              )}
              {q.label}
            </Select.Option>
          );
        })}
      </Select>

      <Select
        onChange={(value) => {
          onChange("if", { ...props.if, type: value });
        }}
        value={props.if.type}
      >
        <Select.Option value="is">برابر</Select.Option>
        <Select.Option value="not_equal">مخالف</Select.Option>
        {selectedQuestion && selectedQuestion.field_type === "number" && (
          <>
            <Select.Option value="greater">بزرگتر</Select.Option>
            <Select.Option value="smaller">کوچکتر</Select.Option>
            <Select.Option value="greater_than_equal">
              بزرگتر مساوی
            </Select.Option>
            <Select.Option value="smaller_than_equal">
              کوچکتر مساوی
            </Select.Option>
          </>
        )}
      </Select>

      {selectedQuestion &&
      Array.isArray(selectedQuestion.options) &&
      selectedQuestion.options.length > 0 ? (
        <Select
          showSearch
          filterOption={(input, option) => {
            return option.children?.search(ConvertNumbersToEn(input)) !== -1;
          }}
          value={props.if.value}
          onChange={(value) => {
            onChange("if", { ...props.if, value });
          }}
        >
          {selectedQuestion.options.map((opt) => {
            const optionId = `${opt.id}`;
            return <Select.Option value={optionId}>{opt.label}</Select.Option>;
          })}
        </Select>
      ) : selectedQuestion && selectedQuestion.field_type === "number" ? (
        <Input
          type="number"
          value={props.if.value}
          onChange={(e) => {
            onChange("if", { ...props.if, value: e.target.value });
          }}
        />
      ) : (
        <div style={{ textAlign: "center" }}> - </div>
      )}
    </div>
  );
};

export default memo(Condition);
